import React from 'react';
import {
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerHeader,
  DrawerBody,
  DrawerCloseButton,
  Text,
} from '@chakra-ui/react';
import TesseramentoRapido, { canBookWithTessera } from '../TesseramentoRapido';

/**
 * Checkout evento con tesseramento rapido (event.checkoutMode
 * 'tesseramento_rapido'): prima la tessera, poi `onContinue` apre il drawer di
 * iscrizione soci con il nuovo account già autenticato. Per gli eventi
 * gratuiti senza varianti l'iscrizione avviene insieme alla tessera.
 */
const TesseramentoRapidoDrawer = ({
  isOpen,
  onClose,
  placement,
  event,
  onContinue,
}) => (
  <Drawer isOpen={isOpen} placement={placement} size="md" onClose={onClose}>
    <DrawerOverlay />
    <DrawerContent maxH={placement === 'bottom' ? '92vh' : undefined}>
      <DrawerCloseButton />
      <DrawerHeader borderBottomWidth="1px">
        Tesserati e iscriviti
        <Text fontSize="sm" fontWeight="normal" color="gray.500" mt={1}>
          {event?.Nome ? `${event.Nome} · ` : ''}per partecipare serve la
          tessera associativa.{' '}
          {canBookWithTessera(event)
            ? 'Con la tessera ti iscriviamo subito.'
            : 'Prima la tessera, poi scegli l’iscrizione.'}
        </Text>
      </DrawerHeader>
      <DrawerBody py={6}>
        <TesseramentoRapido
          embedded
          autoLogin
          event={event}
          onContinue={onContinue}
          onDone={onClose}
        />
      </DrawerBody>
    </DrawerContent>
  </Drawer>
);

export default TesseramentoRapidoDrawer;
